import store from '@/store'
import { firebase } from '@firebase/app'
import '@firebase/firestore'
import '@firebase/auth'
import config from 'appconfig'
import '@firebase/storage'
import '@firebase/functions'
import _ from 'lodash'
firebase.initializeApp(config.firebase)
import { startsWith } from 'lodash'
import namisconfig from 'namisconfig'
var namis = firebase.initializeApp(namisconfig.firebase, 'namis')
// firebase.functions().useFunctionsEmulator('http://localhost:5000')

const autoLoginNaf = () => {
  if(startsWith(window.location.hash, '#/?email=')) {
    $auth.loginNafoods()
  }
}

firebase.auth().onAuthStateChanged(async (userRoot) => {
  namis.auth().onAuthStateChanged(async (userNamis) => {
    let user = userRoot || userNamis
    if (user) {
      let p  = $query(['Users', user.email])
      let f  = $query(['Masterdata', 'Farm'])
      let m  = $query(['Masterdata', 'Meka'])
      let j  = $query(['Masterdata', 'Jobs'])
      Promise.all([p,f,m,j]).then(res => {
        store.dispatch('registerPermission', res[0])
        store.dispatch('registerUser', user)
        store.dispatch('registerFarm', res[1])
        store.dispatch('registerMeka', res[2])
        store.dispatch('registerJobs', res[3])
      })
    } else {
      store.dispatch('registerUser', null)
      store.dispatch('registerPermission', null)
      autoLoginNaf()
    }
  })
})

const $auth = {
  login: function (email, password) {
    try {
      return firebase.auth().signInWithEmailAndPassword(email, password)
    }
    catch (err) {
      console.log(err)
    }
  },
  loginNafoods: function () {
    const provider = new firebase.auth.GoogleAuthProvider()
    provider.setCustomParameters({ 'prompt': 'select_account' })
    provider.setCustomParameters({ 'login_hint': '@nafoods.com' })
    provider.setCustomParameters({ 'hd': 'nafoods.com' })
    provider.addScope('https://www.googleapis.com/auth/calendar.readonly')
    return namis.auth().signInWithRedirect(provider)
  },
  logout: function () {
    firebase.auth().signOut()
    namis.auth().signOut()
  },
  resetPass: (email) => {
    return firebase.auth().sendPasswordResetEmail(email)
  }
}

const firestore = firebase.firestore()

const $query = function (reference, filter) {
  let ref = firestore
  let isCollection = false
  reference.forEach(function (id) {
    isCollection = !isCollection
    if (isCollection) {
      ref = ref.collection(id)
    } else {
      ref = ref.doc(id)
    }
  })
  let res_
  if (!isCollection) {
    res_ = ref.get().then(function (doc) {
      return doc.data()
    })
  } else {
    if (filter) {
      filter.forEach(function (condition) {
        ref = ref.where(condition[0], condition[1], condition[2])
      })
    }
    res_ = ref.get().then(function (querySnapshot) {
      let docs = []
      querySnapshot.forEach(function (doc) {
        docs.push(Object.assign({ _id: doc.id }, doc.data()))
      })
      return {
        data: docs
      }
    })
  }
  return res_.catch(function (error) {
    return {
      error: error
    }
  })
}

const $getNameById = function (collection, val, nameField) {
  for (let i in collection) {
    if (_.isEqual(collection[i].id, val)) {
      return collection[i][nameField]
    }
  }
  return ''
}

const $storage = firebase.storage()

export default {
  // eslint-disable-next-line no-unused-vars
  install (Vue, options) {
    Vue.prototype.$auth = $auth
    Vue.prototype.$query = $query
    Vue.prototype.$storage = $storage
    Vue.prototype.$getNameById = $getNameById
  }
}
